import { TooltipDirective } from '@/directives/tooltip/tooltip.directive';
import { ActionService } from '@/services/action.service';
import { AppConfigService } from '@/services/app-config.service';
import { NotificationCheckService } from '@/services/notification-check.service';

import { Component, OnDestroy, OnInit, inject } from '@angular/core';
import { MatBadgeModule } from '@angular/material/badge';
import { MatIconModule } from '@angular/material/icon';
import { MatListModule } from '@angular/material/list';
import { RouterLink, RouterLinkActive } from '@angular/router';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-main-menu-right',
  imports: [RouterLink, RouterLinkActive, MatIconModule, MatBadgeModule, TooltipDirective, MatListModule],
  templateUrl: './main-menu-right.component.html',
  styleUrl: './main-menu-right.component.scss',
})
export class MainMenuRightComponent implements OnInit, OnDestroy {
  private notificationCheckService = inject(NotificationCheckService);
  private actionService = inject(ActionService);
  private appConfigService = inject(AppConfigService);

  helpPath = '/help';
  notificationsPath = '/notifications';

  showHelp = false;
  notificationsCount = '';
  notificationsTooltipInitial = 'Centre de notifications';
  notificationsTooltip = this.notificationsTooltipInitial;

  sub = new Subscription();
  ngOnInit(): void {
    this.showHelp = this.appConfigService.isMobileOrTablet;
    this.sub = this.notificationCheckService.notificationCount.subscribe((count) => {
      if (count > 0) {
        this.notificationsCount = '' + count;
        if (count > 1) {
          this.notificationsTooltip = count + ' nouvelles notifications disponibles';
        } else {
          this.notificationsTooltip = '1 nouvelle notification disponible';
        }
      } else {
        this.notificationsCount = '';
        this.notificationsTooltip = this.notificationsTooltipInitial;
      }
    });
  }

  ngOnDestroy(): void {
    this.sub.unsubscribe();
  }
}
